const T = {
  LEFT: "left",
  CENTER: "center",
  RIGHT: "right"
};
export {
  T as TEXT_ALIGNMENT
};
//# sourceMappingURL=TextAlignment.js.map
